import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-primary-950 text-background-100 mt-16">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2 max-w-sm">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-md bg-accent-500 flex items-center justify-center">
                <i className="ri-film-fill text-lg text-primary-950"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">缘之空</span>
            </div>
            <p className="text-sm text-background-100/70 leading-relaxed">
              缘之空是一个聚焦高清电影与电视剧的资讯与剧情介绍平台，用清晰的分类、详尽的剧情解析与及时的影视动态，帮你更快找到想看的那一部。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <span className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center text-background-100 hover:bg-accent-500 hover:text-primary-950 transition-colors cursor-pointer">
                <i className="ri-wechat-line"></i>
              </span>
              <span className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center text-background-100 hover:bg-accent-500 hover:text-primary-950 transition-colors cursor-pointer">
                <i className="ri-weibo-line"></i>
              </span>
              <span className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center text-background-100 hover:bg-accent-500 hover:text-primary-950 transition-colors cursor-pointer">
                <i className="ri-mail-line"></i>
              </span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4">站内导航</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/" className="text-background-100/70 hover:text-accent-400 transition-colors">首页</Link></li>
              <li><Link to="/special" className="text-background-100/70 hover:text-accent-400 transition-colors">影视专题</Link></li>
              <li><Link to="/search" className="text-background-100/70 hover:text-accent-400 transition-colors">搜索影视</Link></li>
              <li><Link to="/about" className="text-background-100/70 hover:text-accent-400 transition-colors">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4">热门分类</h4>
            <ul className="space-y-2.5 text-sm">
              {categories.map((c) => (
                <li key={c.slug}>
                  <Link to={`/category/${c.slug}`} className="text-background-100/70 hover:text-accent-400 transition-colors">
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-100/60">
          <p>© {year} 缘之空 · 影视资讯与剧情介绍平台</p>
          <p>本站内容为演示示例，影视资讯与剧情信息仅供参考。</p>
        </div>
      </div>
    </footer>
  );
}